<template>
  <div class="header">
    <div class="headerLeft">
      <h3>{{factoryName}}设备管理系统</h3>
    </div>
    <div class="headerRight">
      <div  @mouseover="showPop=true" @mouseleave="showPop=false"><div class="userIcon"><img src="../assets/user_icon.png"></div><span class="userNumber">admin</span><div class="downArrow"><img src="../assets/down_arrow.png"></div></div>
      <el-collapse-transition>
        <div class="headerRightPop" v-show="showPop"  @mouseover="showPop=true" @mouseout="showPop=false">
          <ul>
            <li class="userName"><span>admin</span></li>
            <li class="exit" style="cursor: pointer;" @click="logOut"><span>退出登录</span></li>
          </ul>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      showPop:false,
      factoryName:localStorage.getItem('factoryName')
    }
  },
  methods:{
    logOut(){
      localStorage.clear()
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  .header {
    height:60px;
    background:#f2f3f5;
  }
  .headerLeft {
    width:250px;
    height:60px;
    float: left;
  }
  .headerLeft h3 {
    font-size:19px;
    font-family:"Microsoft YaHei";
    line-height:60px;
    margin:0;
    margin-left:5px;
  }
  .headerRight {
    width:190px;
    margin-right:120px;
    height:60px;
    line-height:60px;
    position:relative;
    float:right;
  }
  .headerRight span {
    width:70px;
    display: inline-block;
  }
  .userIcon {width:18px;height:18px;margin:10px;margin-right:12px;margin-top:5px;float: left;}
  .userNumber {color:#555;line-height: 40px;}
  .downArrow {width:9px;height:9px;margin:0px;margin-top:-2px;margin-right:35px;float: right;}
  .headerRightPop {width:170px;box-shadow:#ddd 0px 0px 10px;border-radius:4px;position:absolute;top:10px;right:30px;background:#fff;z-index:1000;}
  .headerRightPop ul {padding-top:5px;padding-bottom:5px;}
  .headerRightPop ul li {color:#555;height:40px;line-height:40px;}
  .headerRightPop ul li span {padding-left:30px;margin-left:20px;}
  .exit span {background:url(../assets/exit_icon.png) left center no-repeat;}
  .exit:hover span {background:url(../assets/exit_icon_over.png) left center no-repeat;}
  .userName span {background:url(../assets/user_icon.png) left center no-repeat;}
  .userName:hover span {background:url(../assets/user_icon_over.png) left center no-repeat;}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue